import Axios from '../config/axios';

export function getDomainsByOrganization(org_ID) {
    return Axios.get('/api/GetDomainsByOrganization', {
        params: {
            org_ID
        }
    }).then(response => response.data).catch(error => error);
}